/* eslint-disable jsx-a11y/img-redundant-alt */
import React, { useContext, useEffect, useState } from 'react';
import axios from 'axios';
import { GlobalState } from '../../../../../globalState';
import { useSelector } from 'react-redux';
import DashNavbar from '../../navbar/Navbar';
import DashMenu from '../../menu/DashMenu';
import DashFooter from '../../footer/DashFooter';
import i18n from '../../../../../i18n';
import { useTranslation } from 'react-i18next';
import { appAddress } from '../../../../../App';
import { toast } from 'react-toastify';

export default function AddProject() {
  const {t} = useTranslation()

  const state = useContext(GlobalState);
  const [newProject, setNewProject] = useState({
    title: '',
    designer: '',
    employe: '',
    desc: '',
    pTitle: '',
    pDesigner: '', 
    pEmploye: '', 
    pDesc: '', 
    aTitle: '', 
    aDesigner: '', 
    aEmploye: '', 
    aDesc: '',
  });
  const [images, setImages] = useState([]);
  const [imagePreviews, setImagePreviews] = useState([]);
  const [progress, setProgress] = useState(0);
  const [uploading, setUploading] = useState(false)
  const [token] = useSelector(state => state.token);
  const [callback, setCallback] = state.projectsAPI.callback;

  useEffect(() => {
    const savedLanguage = localStorage.getItem('language') || 'en';
    i18n.changeLanguage(savedLanguage);

    const rootElement = document.getElementById('root');
    if (savedLanguage === 'fa' || savedLanguage === 'ar') {
      rootElement.classList.remove('ltr', 'text-left');
      rootElement.classList.add('rtl', 'text-right');
    } else {
      rootElement.classList.remove('rtl', 'text-right');
      rootElement.classList.add('ltr', 'text-left');
    }
  }, []);

  const handleChangeInput = (e) => {
    const { name, value } = e.target;
    setNewProject({ ...newProject, [name]: value });
  };

  const handleImageChange = (e) => {
    const files = Array.from(e.target.files);

    // Append new files to existing images
    setImages(prevImages => [...prevImages, ...files]);

    // Append new file previews to existing previews
    const newImagePreviews = files.map(file => URL.createObjectURL(file));
    setImagePreviews(prevPreviews => [...prevPreviews, ...newImagePreviews]);
  };

  const handleRemoveImage = (index) => {
    const updatedImages = images.filter((_, i) => i !== index);
    const updatedPreviews = imagePreviews.filter((_, i) => i !== index);

    setImages(updatedImages);
    setImagePreviews(updatedPreviews);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setProgress(0);
    setUploading(true);

    try {
      const formData = new FormData();
      formData.append('title', newProject.title);
      formData.append('designer', newProject.designer);
      formData.append('employe', newProject.employe);
      formData.append('desc', newProject.desc);
      formData.append('pTitle', newProject.pTitle);
      formData.append('pDesigner', newProject.pDesigner);
      formData.append('pEmploye', newProject.pEmploye);
      formData.append('pDesc', newProject.pDesc);
      formData.append('aTitle', newProject.aTitle);
      formData.append('aDesigner', newProject.aDesigner);
      formData.append('aEmploye', newProject.aEmploye);
      formData.append('aDesc', newProject.aDesc);
  
      
      images.forEach(image => formData.append('images', image));
  
      await axios.post(`${appAddress}/api/projects`, formData, {
      // await axios.post('/api/projects', formData, {
        headers: {
          Authorization: token,
          'Content-Type': 'multipart/form-data'
        },
        onUploadProgress: (progressEvent) => {
          const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
          setProgress(percentCompleted);
        }
      });
  
      setNewProject({ title: '', designer: '', employe: '', desc: '', pTitle: '', pDesigner: '', pEmploye: '', pDesc: '', aTitle: '', aDesigner: '', aEmploye: '', aDesc: '', });
      setImages([]);
      setImagePreviews([]);
      setProgress(0)
      toast.success('Project added successfully', {
        position: "bottom-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      setCallback(!callback);
    } catch (err) {
      toast.error(err.response.data.msg, {
              position: "bottom-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
    }
  };

  return (
    <div className='ltr bg-[#2a3447] text-teal-50'>
      <DashNavbar />
      <div className='flex'>
        <div className='w-[250px] p-5 border-r-4'>
          <DashMenu />
        </div>
        <div className='p-4 w-[100%] flex flex-col items-center font-englishTitle'>
          <h2 className='text-3xl'> {t("NewProject")}</h2>
          <hr className='bg-slate-400 w-[25%] mt-3 mb-12'/>
          <form onSubmit={handleSubmit} className='laptop:w-[100%] tablet:w-[95%] h-[750px] tablet:h-fit  mt-6 flex flex-col items-center justify-between '>
           {/* images */}
          <div className='w-[100%] desktop:w-[95%] laptop:h-[600px] desktop:h-[550px] desktopXL:h-[400px] flex flex-col desktop:flex-row gap-2 mt-5 items-center border border-slate-300'>
              <input onChange={handleImageChange} type="file" className='m-1 p-3 w-[50%]' id="imageInput" name="images" accept="image/*" multiple />
              <div className='w-[100%] laptop:h-[500px] desktop:h-[550px] desktopXL:h-[400px] p-2  rounded grid grid-cols-2 laptop:grid-cols-3 desktop:grid-cols-3 desktopXL:grid-cols-4 gap-3 justify-around'>
                {imagePreviews.map((image, index) => (
                  <div key={index} className='relative w-[95%] h-[100px] m-2'>
                    <img src={image} alt={`image-${index}`} className='h-[100%] w-[100%]' />
                    <button type="button" onClick={() => handleRemoveImage(index)} className='absolute w-[30px] top-1 right-2 bg-red-500 text-white rounded-full p-1 m-1 hover:bg-red-700'>
                      X
                    </button>
                  </div>
                ))}
              </div>
            </div>
            {/* text */}
            <div className='flex flex-col desktop:flex-row w-[90%] gap-5'>
                {/* english */}
            <div className='w-[100%] desktop:w-[70%] h-[300px] flex flex-col justify-around items-center mt-4 border border-slate-400'>
              <h4 className='text-2xl text-orange-500 font-persian'>{t("English")}</h4>
              <hr className='text-slate-300 p-1 w-[25%]'/>
              <input type="text" name="title" value={newProject.title} onChange={handleChangeInput} placeholder={t("ProjectName")} className='m-1 w-[80%] p-1 text-slate-950 border border-slate-600 text-center' />
              <input type="text" name="designer" value={newProject.designer} onChange={handleChangeInput} placeholder={t("Designer")} className='m-1 w-[80%] p-1 text-slate-950 border border-slate-600 text-center' />
              <input type="text" name="employe" value={newProject.employe} onChange={handleChangeInput} placeholder={t("Employer")} className='m-1 w-[80%] p-1 text-slate-950 border border-slate-600 text-center' />
              <textarea name="desc" value={newProject.desc} onChange={handleChangeInput} placeholder={t("Description")} className='m-1 w-[80%] p-1 text-slate-950 border border-slate-600 text-center' />
            </div>
            {/* persian */}
            <div className='w-[100%] desktop:w-[70%]  h-[300px] flex flex-col justify-around items-center mt-4 border border-slate-400'>
              <h4 className='text-2xl text-orange-500 font-persian'>{t("Persian")}</h4>
              <hr className='text-slate-300 p-1 w-[25%]'/>
              <input type="text" name="pTitle" value={newProject.pTitle} onChange={handleChangeInput} placeholder={t("ProjectName")} className='m-1 w-[80%] p-1 text-slate-950 border border-slate-600 text-center' />
              <input type="text" name="pDesigner" value={newProject.pDesigner} onChange={handleChangeInput} placeholder={t("Designer")} className='m-1 w-[80%] p-1 text-slate-950 border border-slate-600 text-center' />
              <input type="text" name="pEmploye" value={newProject.pEmploye} onChange={handleChangeInput} placeholder={t("Employer")} className='m-1 w-[80%] p-1 text-slate-950 border border-slate-600 text-center' />
              <textarea name="pDesc" value={newProject.pDesc} onChange={handleChangeInput} placeholder={t("Description")} className='m-1 w-[80%] p-1 text-slate-950 border border-slate-600 text-center' />
            </div>
            {/* arabic */}
            <div className='w-[100%] desktop:w-[70%]  h-[300px] flex flex-col justify-around items-center mt-4 border border-slate-400'>
              <h4 className='text-2xl text-orange-500 font-persian'>{t("Arabic")}</h4>
              <hr className='text-slate-300 p-1 w-[25%]'/>
              <input type="text" name="aTitle" value={newProject.aTitle} onChange={handleChangeInput} placeholder={t("ProjectName")} className='m-1 w-[80%] p-1 text-slate-950 border border-slate-600 text-center' />
              <input type="text" name="aDesigner" value={newProject.aDesigner} onChange={handleChangeInput} placeholder={t("Designer")} className='m-1 w-[80%] p-1 text-slate-950 border border-slate-600 text-center' />
              <input type="text" name="aEmploye" value={newProject.aEmploye} onChange={handleChangeInput} placeholder={t("Employer")} className='m-1 w-[80%] p-1 text-slate-950 border border-slate-600 text-center' />
              <textarea name="aDesc" value={newProject.aDesc} onChange={handleChangeInput} placeholder={t("Description")} className='m-1 w-[80%] p-1 text-slate-950 border border-slate-600 text-center' />
            </div>
            </div>
           
            {uploading && (
  <div className="w-[80%] m-auto p-2 mt-6 bg-gray-300 rounded-full">
    <div
      className="h-4 transition-all rounded-full bg-sky-700"
      style={{ width: `${progress}%` }}
    ></div>
  </div>
)}
            
            <button type='submit' className='text-white hover:text-white bg-green-700 hover:bg-slate-900 w-[30%] desktop:w-[10%] mt-8 mb-5 rounded-lg'>{t("submit")}</button>
          </form>
        </div>
      </div>
      <DashFooter />
    </div>
  );
}
